var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59 30c0 16.632-13.99 29.987-30.848 28.943-14.444-.895-26.2-12.651-27.094-27.095-1.045-16.858 12.31-30.848 28.942-30.848 4.568 0 8.893 1.054 12.74 2.941 1.031.506 1.409 1.79.84 2.788l-.004.007c-.526.922-1.674 1.265-2.626.796-3.818-1.88-8.183-2.795-12.79-2.466-12.1.863-21.982 10.568-23.059 22.651-1.34 15.039 10.712 27.662 25.563 27.274 12.718-.332 23.334-10.418 24.265-23.106.242-3.296-.155-6.487-1.099-9.429-.299-.933.136-1.94 1.012-2.378 1.094-.547 2.435 0 2.806 1.165.878 2.761 1.351 5.703 1.351 8.757z",
    fill: "#aee090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.41 22.472 15.814 21.397c1.194 1.616 3.624 1.476 4.631-.266l22.852-39.558c1.19-2.06-1.525-4.131-3.144-2.397l-23.808 25.502-13.814-7.646c-1.867-1.033-3.807 1.241-2.531 2.968z",
    fill: "#6bb577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.583e9c11e100d47e1faa3e19ad475f15.svg";
export { ForwardRef as ReactComponent };